import { render, staticRenderFns } from "./LexWeb.vue?vue&type=template&id=50a86736&"
import script from "./LexWeb.vue?vue&type=script&lang=js&"
export * from "./LexWeb.vue?vue&type=script&lang=js&"
import style0 from "./LexWeb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/q7gCdwre/0/h5group/renpho-lex/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50a86736')) {
      api.createRecord('50a86736', component.options)
    } else {
      api.reload('50a86736', component.options)
    }
    module.hot.accept("./LexWeb.vue?vue&type=template&id=50a86736&", function () {
      api.rerender('50a86736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LexWeb.vue"
export default component.exports